<template>
  <div
    class="comparison"
  >
    <div class="devices">
      <div
        v-for="(d, index) in devices.slice(0, numbers)"
        :key="index"
        class="device-wrap"
      >
        <div class="image-wrap">
          <img :src="d.image">
        </div>
        <div class="device-name">
          <h2>{{ d.name }}</h2>
        </div>
        <button
          :class="['btn-buy-device', {primary: index === 0}]"
          v-if="themeName === 'movistar'"
        >
          <a
            href="https://tienda.movistar.com.pe/celulares-liberados?utm_source=WP&utm_medium=ACCIONES&utm_campaign=PE_MOVIL_COL-DO-EQUIPOSLIBERADOS-B2C_2021-12-20_WEB_LDS-WEB_0_NA&utm_content=ACCIONES-RAPIDAS-HOME"
            class="buy-device-link"
          >{{ $t('advisor.buy_now') }}</a>
        </button>
      </div>
    </div>
    <div class="specs-values">
      <div
        class="spec-group"
        v-for="(group, i) in specs"
        :key="i"
      >
        <h4>{{ group.name }}</h4>
        <div
          v-for="(s, j) in group.specs"
          :key="j"
          class="group-specs"
        >
          <div class="titles-cell">
            {{ s.name }}
          </div>
          <div
            class="value-cell"
            v-for="(v, k) in s.values"
            :key="k"
          >
            <span v-if="!v || v === 'empty'">-</span>
            <span v-else-if="v.value">{{ v.value }}</span>
            <span v-else>
              <span
                v-if="v.isSupported !== null"
                class="support-spec"
              >{{ $t('all.text_' + (v.isSupported ? 'yes' : 'no')) }}</span>
              <span v-else>-</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <RotateDeviceOverlay
      v-if="themeName === 'movistar'"
      :text="'Para una mejor experiencia de visualización, gira tu dispositivo'"
    />
  </div>
</template>

<script>
import RotateDeviceOverlay from '~/components/RotateDeviceOverlay'
import { _uniqBy } from '~/utils'

export default {
  props: {
    devices: { type: Array, default: () => [] },
    numbers: { type: Number, default: 3 }
  },
  components: {
    RotateDeviceOverlay
  },
  data () {
    const themeName = typeof CLIENT !== 'undefined' ? CLIENT.theme : 'generic'
    return {
      themeName: themeName || 'generic'
    }
  },
  computed: {
    specs () {
      if (this.devices.length === 0) return []
      return this.getSpecs()
    }
  },
  methods: {
    getSpecs () {
      let combinedDevices = []
      const specificationGroups = []
      this.devices.forEach((device) => {
        if (device == null) return
        combinedDevices = [...combinedDevices, ...(device.specificationGroups || [])]
      })
      combinedDevices.forEach((el) => {
        const duplicate = specificationGroups.find((x) => x.name === el.name)
        if (duplicate) {
          const combinedSpecs = _uniqBy([...el.specifications, ...duplicate.specifications], 'name')
          duplicate.specifications = combinedSpecs
        } else {
          specificationGroups.push({ ...el })
        }
      })
      return specificationGroups.map(g => ({
        name: g.name,
        specs: g.specifications.map(s => ({
          name: s.name,
          values: this.devices
            .slice(0, this.numbers)
            .map(d => (d ? this.getSpecForDevice(d.id, g.name, s.name) : 'empty'))
        }))
      }))
    },
    getSpecForDevice (id, groupName, specName) {
      const spec = this.devices.find(x => x.id === id)
      if (spec) {
        const group = spec.specificationGroups.find(g => g.name === groupName)
        return group && group.specifications.find(s => s.name === specName)
      } else {
        return {}
      }
    }
  }
}
</script>

<style lang="scss">
.comparison {
  .devices {
    display: flex;
    padding-left: 30%;
    .device-wrap {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .image-wrap {
        height: 120px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
  .specs-values {
    .spec-group {
      margin: 15px 0;

      h4 {
        font-size: 16px;
        font-weight: 600;
        line-height: 18px;
      }

      .group-specs {
        display: flex;

        .titles-cell,
        .value-cell {
          font-size: 12px;
          line-height: 14px;
        }

        .titles-cell {
          width: 30%;
        }
        .value-cell {
          width: 23.33%;
        }
      }
    }
  }
}
</style>
